/* AdVille · Pupakiotti · 28/09/2026
   Carrello laterale (R8), suggerimenti nel carrello (R7) e set nello stesso
   colore sulla scheda prodotto (R9).
   Niente HTML costruito qui: il markup lo genera Liquid e arriva dalla
   Section Rendering API. Se qualcosa va storto non si inventa niente: si
   manda alla pagina carrello, che funziona sempre. */
/* 12/10/2026 (Simone): i testi che questo file scrive si leggono dalla pagina (snippet av-testi e i
   nomi del modulo del set), cosi' GTranslate li traduce come il resto; le sezioni si chiedono in HTML
   (section_id), che GTranslate traduce, invece che in JSON (sections), che non traduce. */
(function () {
  'use strict';
  var mappa = null;
  window.avK = function (s) {
    if (s == null || s === '') return s;
    if (!mappa) {
      mappa = {};
      Array.prototype.forEach.call(document.querySelectorAll('[data-av-k]'), function (e) {
        var t = e.textContent.trim();
        if (t) mappa[e.getAttribute('data-av-k')] = t;
      });
    }
    return mappa[s] || s;
  };
  window.avT = function (chiave, val) {
    var e = document.querySelector('#av-testi [data-av-t="' + chiave + '"]');
    var it = e ? e.getAttribute('data-av-it') : chiave;
    var tr = e ? e.textContent.trim() : it;
    var segni = it.match(/\{[a-z]\}/g) || [];
    var t = (tr && segni.every(function (s) { return tr.indexOf(s) >= 0; })) ? tr : it;
    Object.keys(val || {}).forEach(function (k) { t = t.split('{' + k + '}').join(val[k]); });
    return t;
  };
})();

(function () {
  'use strict';

  var SEZIONE = 'av-carrello';
  var radice = document.getElementById('av-carrello');
  if (!radice) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function apri() {
    radice.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('av-carrello-aperto');
    var x = radice.querySelector('.av-carrello__chiudi');
    if (x) x.focus({ preventScroll: true });
  }

  function chiudi() {
    radice.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('av-carrello-aperto');
  }

  function vaiAlCarrello() { window.location.href = root + 'cart'; }

  /* Per il costruttore del set (30/09): aggiorna e apre il pannello. */
  window.avApriCarrello = function () { return aggiorna().then(apri); };

  function aggiorna() {
    return fetch(window.location.pathname + '?section_id=' + SEZIONE, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('sezione non disponibile: ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html || '';
        var nuovo = tmp.querySelector('#av-carrello');
        if (!nuovo) throw new Error('pannello non trovato');
        var aperto = radice.getAttribute('aria-hidden') === 'false';
        radice.innerHTML = nuovo.innerHTML;
        radice.setAttribute('aria-hidden', aperto ? 'false' : 'true');
        return aggiornaIcona();
      });
  }

  /* Il numerino sull'icona del carrello nell'intestazione del tema. */
  function aggiornaIcona() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var nodi = document.querySelectorAll('.header-cart .cart-count, .header-cart__count, [data-cart-count]');
        Array.prototype.forEach.call(nodi, function (n) { n.textContent = c.item_count; });
      })
      .catch(function () {});
  }

  function aggiungi(idVariante, bottone) {
    if (bottone) { bottone.disabled = true; bottone.classList.add('av-in-corso'); }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-AdVille': '1' },
      body: JSON.stringify({ items: [{ id: Number(idVariante), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('aggiunta rifiutata: ' + r.status);
      return aggiorna();
    }).then(apri);
  }

  function cambiaQuantita(chiave, valore) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: chiave, quantity: valore })
    }).then(function (r) {
      if (!r.ok) throw new Error('quantita rifiutata: ' + r.status);
      return aggiorna();
    });
  }

  /* Un solo ascoltatore per tutta la pagina: i contenuti vengono rigenerati,
     agganciare i singoli bottoni li perderebbe a ogni aggiornamento. */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-av-chiudi]') && t.closest('#av-carrello')) {
      e.preventDefault();
      chiudi();
      return;
    }

    var qta = t.closest('[data-av-qta]');
    if (qta) {
      e.preventDefault();
      qta.disabled = true;
      cambiaQuantita(qta.getAttribute('data-av-qta'), Number(qta.getAttribute('data-av-valore')))
        .catch(vaiAlCarrello);
      return;
    }

    var agg = t.closest('[data-av-aggiungi]');
    if (agg) {
      e.preventDefault();
      aggiungi(agg.getAttribute('data-av-aggiungi'), agg).catch(vaiAlCarrello);
      return;
    }

    /* L'icona carrello apre il pannello invece di cambiare pagina. Chi apre
       in una nuova scheda, o non ha JavaScript, va comunque alla pagina. */
    var link = t.closest('.header-cart a, a.header-cart, a[href="' + root + 'cart"]');
    if (link && !link.closest('#av-carrello')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      aggiorna().then(apri).catch(vaiAlCarrello);
    }
  });

  /* Revisione 2 (S3): pezzo del set nel carrello con menu Colore e, se serve,
     Taglia/Misura. Le varianti arrivano da Liquid (solo quelle disponibili);
     qui si sceglie soltanto fra quelle. Finche' la variante non e' univoca il
     pulsante resta spento. */
  function aggiornaPezzoCarrello(scheda, colore_cambiato) {
    var varianti = [];
    try { varianti = JSON.parse(scheda.querySelector('[data-av-varianti]').textContent); } catch (err) { return; }
    var selC = scheda.querySelector('[data-av-colore]');
    var selA = scheda.querySelector('[data-av-alt]');
    var colore = selC ? selC.value : '';
    var perColore = varianti.filter(function (v) { return v.c === colore; });

    if (selA && colore_cambiato) {
      var segnaposto = selA.options[0].cloneNode(true);
      segnaposto.selected = true;
      selA.innerHTML = '';
      selA.appendChild(segnaposto);
      perColore.forEach(function (v) {
        var o = document.createElement('option');
        o.value = v.a;
        o.textContent = v.a + ' · ' + v.p;
        selA.appendChild(o);
      });
      if (perColore.length === 1) selA.value = perColore[0].a;
    }

    var scelta = null;
    if (selA) {
      scelta = perColore.filter(function (v) { return v.a === selA.value; })[0] || null;
    } else {
      scelta = perColore[0] || null;
    }

    var bottone = scheda.querySelector('[data-av-aggiungi]');
    var prezzo = scheda.querySelector('[data-av-prezzo]');
    var foto = scheda.querySelector('[data-av-foto]');
    if (scelta) {
      bottone.setAttribute('data-av-aggiungi', scelta.id);
      bottone.disabled = false;
      if (prezzo) prezzo.textContent = scelta.p;
    } else {
      bottone.setAttribute('data-av-aggiungi', '');
      bottone.disabled = true;
      /* prezzo "da": il minimo del colore scelto, o di tutti se il colore manca */
      var base = perColore.length ? perColore : varianti;
      var minimo = base.reduce(function (m, v) { return (!m || v.n < m.n) ? v : m; }, null);
      if (prezzo && minimo) prezzo.textContent = 'da ' + minimo.p;
    }
    var perFoto = scelta || perColore[0];
    if (foto && perFoto && perFoto.f) foto.src = perFoto.f;
  }

  /* Scheda prodotto (S8): quantita' con - e + ai lati del numero. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-av-q]');
    if (!b) return;
    e.preventDefault();
    var campo = b.closest('.av-quantita').querySelector('input[name="quantity"]');
    var n = (parseInt(campo.value, 10) || 1) + Number(b.getAttribute('data-av-q'));
    campo.value = Math.max(1, n);
    campo.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Misura del pezzo (guinzaglio 12 o 20 mm): il bottone aggiunge quella scelta. */
  document.addEventListener('change', function (e) {
    var menuCarrello = e.target.closest('[data-av-colore], [data-av-alt]');
    if (menuCarrello) {
      var scheda = menuCarrello.closest('[data-av-pezzo-carrello]');
      if (scheda) aggiornaPezzoCarrello(scheda, menuCarrello.hasAttribute('data-av-colore'));
      return;
    }
    var sel = e.target.closest('[data-av-scelta]');
    if (sel) {
      var riga = sel.closest('[data-av-pezzo]');
      var bottone = riga && riga.querySelector('[data-av-aggiungi]');
      if (bottone) bottone.setAttribute('data-av-aggiungi', sel.value);
      var opz = sel.options[sel.selectedIndex];
      var foto = riga && riga.querySelector('[data-av-foto]');
      if (foto && opz && opz.getAttribute('data-av-foto')) foto.src = opz.getAttribute('data-av-foto');
      return;
    }

    /* Scheda prodotto: cambiato il colore, si rigenera "Il set nello stesso colore". */
    var form = e.target.closest('form[action*="/cart/add"]');
    if (form) {
      /* PageFly aggiorna la variante con un attimo di ritardo: un secondo
         controllo (idempotente) la prende comunque. */
      setTimeout(function () { aggiornaSet(form); }, 60);
      setTimeout(function () { aggiornaSet(form); }, 500);
    }
  });

  function aggiornaSet(form) {
    var blocco = document.querySelector('[data-av-set]');
    var campo = form.querySelector('[name="id"]');
    if (!blocco || !campo || !campo.value) return;
    if (blocco.getAttribute('data-av-variante') === campo.value) return;
    blocco.setAttribute('data-av-variante', campo.value);
    var url = blocco.getAttribute('data-av-url') + '?variant=' + encodeURIComponent(campo.value) + '&section_id=av-set-colore';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html || '';
        var nuovo = tmp.querySelector('[data-av-set]');
        if (nuovo) blocco.innerHTML = nuovo.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && radice.getAttribute('aria-hidden') === 'false') chiudi();
  });

  /* Aggiunta da un pulsante che non e' del tema (PageFly, pagina del Set 3
     pezzi, 30/09): usa fetch. Se l'aggiunta riesce si apre il carrello
     laterale, come dal pulsante della scheda (S2). Le nostre aggiunte hanno
     l'intestazione X-AdVille e aprono gia' il pannello da sole. */
  if (window.fetch && !window.__avFetch) {
    window.__avFetch = true;
    var fetchOriginale = window.fetch;
    window.fetch = function (risorsa, opzioni) {
      var promessa = fetchOriginale.apply(this, arguments);
      try {
        var indirizzo = typeof risorsa === 'string' ? risorsa : (risorsa && risorsa.url) || '';
        var nostra = opzioni && opzioni.headers && (opzioni.headers['X-AdVille'] || (typeof opzioni.headers.get === 'function' && opzioni.headers.get('X-AdVille')));
        if (/\/cart\/add/.test(indirizzo) && !nostra) {
          promessa.then(function (r) { if (r && r.ok) setTimeout(function () { aggiorna().then(apri).catch(function () {}); }, 150); }).catch(function () {});
        }
      } catch (err) {}
      return promessa;
    };
  }

  /* Aggiunta dal pulsante del tema: il tema la fa con jQuery ($.post su
     /cart/add.js) e poi mostra il suo avviso. Si aspetta la sua risposta e si
     apre il pannello; l'avviso del tema e' nascosto dal CSS. */
  if (window.jQuery) {
    window.jQuery(document).ajaxSuccess(function (evt, xhr, opzioni) {
      if (opzioni && typeof opzioni.url === 'string' && opzioni.url.indexOf('/cart/add') !== -1) {
        aggiorna().then(apri).catch(function () {});
      }
    });
  }
})();

/* AdVille · Pupakiotti · 30/09/2026 · recensioni in home: frecce solo da
   computer (col mouse una fila orizzontale non si scorre) e testo intero al tocco. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-av-rec]');
    if (f) {
      var fila = f.closest('.testimonials').querySelector('[data-av-recensioni]');
      if (fila) fila.scrollBy({ left: Number(f.getAttribute('data-av-rec')) * fila.clientWidth * 0.9, behavior: 'smooth' });
      return;
    }
    var testo = e.target.closest('.av-recensione__testo');
    if (testo) testo.closest('.av-recensione').classList.toggle('av-aperta');
  });
})();

/* AdVille · Pupakiotti · 30/09/2026 · riscontro del cliente: "implementare il
   bundle sia sui prodotti sfusi che con il set". La scheda del Set 3 pezzi e'
   costruita con PageFly, che non usa la sezione prodotto del tema: il blocco
   "Crea il tuo set coordinato" si chiede alla Section Rendering API (stessa
   sezione av-set-colore della scheda normale) e si mette sotto il modulo
   d'acquisto. Il modello PageFly non si tocca. */
(function () {
  'use strict';
  if (document.querySelector('[data-av-set], [data-av-costruttore]')) return;
  if (!/\/products\//.test(window.location.pathname)) return;
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  var campo = form.querySelector('[name="id"]');
  var url = window.location.pathname + '?section_id=av-set-colore' + (campo && campo.value ? '&variant=' + encodeURIComponent(campo.value) : '');
  fetch(url, { credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
    .then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html || '';
      var blocco = tmp.querySelector('[data-av-set]');
      if (!blocco || document.querySelector('[data-av-set]')) return;
      if (campo && campo.value) blocco.setAttribute('data-av-variante', campo.value);
      blocco.classList.add('av-set--inserito');
      form.insertAdjacentElement('afterend', blocco);
    })
    .catch(function () {});
})();

/* AdVille · Pupakiotti · 30/09/2026 · richiesta di Simone: "nella pagina prodotto
   fai le recensioni nello stesso identico formato della home page, con la foto
   nella stessa posizione, formato uguale e frecce uguali". Le recensioni della
   scheda sono di Judge.me (carosello "featured"): si leggono dalle sue schede
   (stelle, titolo, testo, nome, foto del prodotto recensito) e si rimettono nella
   stessa fila della home, con le stesse classi del tema. Il carosello di
   Judge.me resta nella pagina ma nascosto. Nessun testo viene riscritto. */
(function () {
  'use strict';
  var STELLA = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon feather-star" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';

  function costruisci() {
    var w = document.querySelector('.jdgm-carousel-wrapper');
    if (!w || w.hasAttribute('data-av-fatto')) return true;
    var schede = w.querySelectorAll('.jdgm-carousel-item');
    if (!schede.length) return false;
    w.setAttribute('data-av-fatto', '1');

    var pannello = document.createElement('div');
    pannello.className = 'page-width testimonials large-section global-border-radius av-recensioni-scheda';
    pannello.id = 'av-recensioni';
    var capo = document.createElement('div');
    capo.className = 'testimonials--title text-center';
    var h2 = document.createElement('h2');
    h2.className = 'large-title';
    h2.textContent = avT('recensioni');
    capo.appendChild(h2);
    pannello.appendChild(capo);

    var fila = document.createElement('div');
    fila.className = 'av-recensioni';
    fila.setAttribute('data-av-recensioni', '');
    fila.tabIndex = 0;
    fila.setAttribute('aria-label', avT('recensioni'));
    var viste = {};
    Array.prototype.forEach.call(schede, function (s) {
      var id = s.getAttribute('data-review-id') || '';
      if (id && viste[id]) return;
      viste[id] = true;
      var art = document.createElement('article');
      art.className = 'av-recensione testimonial';

      var stelle = document.createElement('div');
      stelle.className = 'testimonial-stars';
      var n = s.querySelectorAll('.jdgm-star.jdgm--on').length || 5;
      stelle.setAttribute('aria-label', n + '/5');
      for (var i = 0; i < n; i++) {
        var st = document.createElement('span');
        st.className = 'icon feather-icon testimonial-star';
        st.innerHTML = STELLA;
        stelle.appendChild(st);
      }
      art.appendChild(stelle);

      var testo = document.createElement('blockquote');
      testo.className = 'av-recensione__testo testimonial-content rte';
      var titolo = s.querySelector('.jdgm-carousel-item__review-title');
      if (titolo && titolo.textContent.trim()) {
        var pt = document.createElement('p');
        var b = document.createElement('strong');
        b.textContent = titolo.textContent.trim();
        pt.appendChild(b);
        testo.appendChild(pt);
      }
      var corpo = s.querySelector('.jdgm-carousel-item__review-body');
      if (corpo) Array.prototype.forEach.call(corpo.childNodes, function (c) { testo.appendChild(c.cloneNode(true)); });
      art.appendChild(testo);

      var piede = document.createElement('footer');
      piede.className = 'av-recensione__autore testimonial-author-info';
      var img = s.querySelector('.jdgm-carousel-item__product-image');
      var src = img && (img.getAttribute('data-src-retina') || img.getAttribute('data-src') || img.getAttribute('src'));
      if (src && src.indexOf('data:') !== 0) {
        var foto = document.createElement('div');
        foto.className = 'testimonial-author-image rimage-background';
        foto.style.backgroundImage = 'url("' + src.replace(/"/g, '') + '")';
        piede.appendChild(foto);
      }
      var nome = s.querySelector('.jdgm-carousel-item__reviewer-name');
      if (nome && nome.textContent.trim()) {
        var nn = document.createElement('div');
        nn.className = 'testimonial-author-name';
        nn.textContent = nome.textContent.trim();
        piede.appendChild(nn);
      }
      art.appendChild(piede);
      fila.appendChild(art);
    });
    pannello.appendChild(fila);

    var frecce = document.createElement('div');
    frecce.className = 'av-recensioni__frecce';
    frecce.innerHTML = '<button type="button" class="av-recensioni__freccia" data-av-rec="-1">&#8592;</button>' +
                       '<button type="button" class="av-recensioni__freccia" data-av-rec="1">&#8594;</button>';
    frecce.children[0].setAttribute('aria-label', avT('rec_prec'));
    frecce.children[1].setAttribute('aria-label', avT('rec_succ'));
    pannello.appendChild(frecce);

    /* 07/10 (Sergio): un punto d'arrivo per scrivere la recensione senza cercare.
       Il modulo e' quello di Judge.me, nascosto finche' non si preme il pulsante. */
    if (document.querySelector('.jdgm-review-widget')) {
      var scrivi = document.createElement('div');
      scrivi.className = 'av-recensioni__scrivi';
      var bt = document.createElement('button');
      bt.type = 'button';
      bt.className = 'av-recensioni__scrivi-btn';
      bt.textContent = avT('scrivi');
      bt.addEventListener('click', function () { window.avApriRecensione(0); });
      scrivi.appendChild(bt);
      pannello.appendChild(scrivi);
    }

    /* Stesso involucro della sezione della home, allo stesso livello delle
       sezioni della pagina: fuori dal contenitore di Judge.me (largo al massimo
       1080 px, con spaziature azzerate dal suo foglio di stile). */
    var esterno = document.createElement('div');
    esterno.className = 'relative container container--no-mobile-padding large-row av-recensioni-scheda-contenitore';
    esterno.appendChild(pannello);
    var sezione = w.closest('.shopify-section') || w;
    sezione.parentNode.insertBefore(esterno, sezione);
    w.classList.add('av-jdgm-sostituito');
    return true;
  }

  function prova(volte) {
    if (costruisci() || volte <= 0) return;
    setTimeout(function () { prova(volte - 1); }, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prova(12); });
  else prova(12);
})();

/* AdVille · Pupakiotti · 30/09/2026 · guida taglie per ridurre i resi.
   1) La tabella taglie che l'app Panda Size Chart associa a QUESTO prodotto (la stessa del
      link "Guida alle Taglie", che resta com'e') si mostra anche in una sezione della scheda.
      Si copia quello che Panda ha caricato per il prodotto: nessuna tabella scelta a mano.
   2) Pettorine Bustier: accanto alle taglie, la misura del torace della taglia scelta.
      19/10 (Elena): anche pettorine H e Y (torace) e collari (collo), dalla pagina Tabella Taglie.
      Per i collari conta la lettera prima della parentesi: «M (26-31)» e' la M. */
(function () {
  'use strict';
  var MISURE = {
    bustier: { 'micro': '20–26 cm', '2xs': '26–30 cm', 'xs-s': '31–35,5 cm', 'm-l': '36–43 cm', 'xl-xxl': '44–50 cm', '3xl-4xl': '51–62 cm', '5xl': '61–72 cm' },
    h: { 's': '37–46 cm', 'm': '45–54 cm', 'l': '53–62 cm', 'xl': '62–71 cm' },
    y: { 's': '33–44 cm', 'm': '41–55 cm', 'l': '52–69 cm', 'xl': '65–86 cm' },
    suede: { 's': '30–36 cm', 'm': '36–45 cm' },
    // 25/10 (Elena): petto del cane consigliato delle tabelle abbigliamento nuove
    abbigliamento: { 'xs': '27–31 cm', 's': '32–37 cm', 'm': '36–40 cm', 'l': '41–46 cm', 'xl': '47–51 cm', '2xl': '53–57 cm', '1t': '36–40 cm', '2t': '42–46 cm', '3t': '47–51 cm' },
    pupcoat: { '1st': '34–42 cm', '2st': '39–48 cm', '3st': '45–52 cm', '4st': '50–57 cm', '2l': '39–48 cm', '3l': '45–52 cm' },
    collare: { 'xs': '14–19 cm', 's': '19–25 cm', 'm': '26–31 cm', 'l': '32–37 cm', 'xl': '38–43 cm', '2xl': '43–48 cm' },
    levriero: { 's': '19–25 cm', 'm': '28–32 cm', 'l': '33–38 cm' }
  };

  var LUNGHEZZA_PUPCOAT = { '1st': '28 cm', '2st': '32 cm', '3st': '36 cm', '4st': '40 cm', '2l': '37 cm', '3l': '41 cm' };

  function aggiornaTaglia() {
    var nota = document.querySelector('[data-av-taglia-nota]');
    if (!nota) return;
    var tipo = nota.getAttribute('data-av-taglia-tipo') || 'bustier';
    var scelta = document.querySelector('.product-detail .option-selector--taglia input:checked');
    var cm = nota.querySelector('[data-av-taglia-cm]');
    var v = scelta ? scelta.value : '';
    var chiave = String(v).toLowerCase().trim();
    if (tipo === 'collare' || tipo === 'levriero') chiave = chiave.split('(')[0].trim();
    var r = (MISURE[tipo] || {})[chiave];
    var testo = (tipo === 'collare' || tipo === 'levriero') ? 'taglia_collo' : (tipo === 'abbigliamento' || tipo === 'pupcoat') ? 'taglia_petto' : 'taglia_torace';
    // 26/10 (Elena): nel Pup-Coat conta la lunghezza (la larghezza si regola), poi il petto
    var l = tipo === 'pupcoat' ? LUNGHEZZA_PUPCOAT[chiave] : null;
    // 30/10 sera (Elena): accanto alla taglia la lunghezza, «lunghezza standard» o «lunghezza bassotto»,
    // senza i centimetri della lunghezza (i clienti non la sanno misurare); i bulldog restano «per bulldog francesi».
    var g = null;
    if (tipo === 'abbigliamento') {
      if (/^\dt$/.test(chiave)) g = avT('lung_bassotto');
      else if (/^\d$/.test(chiave)) g = avT('per_bulldog');
      else if (chiave) g = avT('lung_standard');
    } else if (tipo === 'pupcoat') {
      // 02/11 (Elena): nel Pup-Coat la misura principale resta la lunghezza, come prima: tutte e due le misure
      if (r && l) { cm.textContent = avT('taglia_lung_petto', { v: v, l: l, r: r }); return; }
    }
    if (g) {
      cm.textContent = r ? avT('taglia_petto_gruppo', { v: v, g: g, r: r }) : avT('taglia_gruppo', { v: v, g: g });
      return;
    }
    cm.textContent = r ? (l ? avT('taglia_lunghezza', { v: v, l: l, r: r }) : avT(testo, { v: v, r: r })) : '';
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.option-selector--taglia')) setTimeout(aggiornaTaglia, 30);
  });
  aggiornaTaglia();

  function guida() {
    if (document.getElementById('av-guida-taglie')) return true;
    // 24/10 (Elena): nell'abbigliamento la tabella resta solo nel link «Guida alle taglie» di Panda.
    if (document.querySelector('[data-av-senza-guida]')) return true;
    var dati = document.getElementById('panda-modal-data-popup');
    if (!dati) return false;
    // Solo la tabella e lo schema delle misure: Panda mette nella stessa finestra anche tutte le
    // foto del prodotto (sulla pettorina 40), che sono gia' nella galleria (Elena, 01/10).
    var immagini = Array.prototype.filter.call(dati.querySelectorAll('img'), function (i) {
      var s = i.getAttribute('src') || i.getAttribute('data-src') || '';
      if (i.closest('.panda-product-image-slider, .panda-modal-product-image')) return false;
      return s && s.indexOf('data:') !== 0;
    });
    var tabelle = dati.querySelectorAll('table');
    if (!immagini.length && !tabelle.length) return false;
    var prodotto = document.querySelector('[data-section-type="product"]');
    var dopo = prodotto && prodotto.closest('.shopify-section');
    if (!dopo) return true;
    var sez = document.createElement('section');
    sez.id = 'av-guida-taglie';
    sez.className = 'av-guida-taglie page-width';
    var h = document.createElement('h2');
    h.className = 'av-guida-taglie__titolo';
    h.textContent = avT('guida');
    sez.appendChild(h);
    var corpo = document.createElement('div');
    corpo.className = 'av-guida-taglie__corpo';
    immagini.forEach(function (i) {
      var src = i.getAttribute('src') || i.getAttribute('data-src');
      var a = document.createElement('a');
      a.href = src; a.target = '_blank'; a.rel = 'noopener';
      var img = document.createElement('img');
      img.src = src; img.alt = avT('guida'); img.loading = 'lazy';
      a.appendChild(img);
      corpo.appendChild(a);
    });
    Array.prototype.forEach.call(tabelle, function (tb) {
      var c = tb.cloneNode(true);
      c.removeAttribute('id');
      var w = document.createElement('div');
      w.className = 'av-guida-taglie__tabella';
      w.appendChild(c);
      corpo.appendChild(w);
    });
    sez.appendChild(corpo);
    dopo.insertAdjacentElement('afterend', sez);
    return true;
  }
  var tentativi = 0;
  (function prova() {
    if (guida() || ++tentativi > 20) return;
    setTimeout(prova, 500);
  })();
})();

/* AdVille · Pupakiotti · "Crea il tuo set e risparmia" sugli articoli Basic, sul modello
   dell'esempio "Build your bundle" di Elena (30/09). Revisione del 01/10 (Simone): tutto dentro i
   margini del riquadro, una riga compatta per articolo (foto piccola, colore, taglia, +), linguette
   a segmenti, livelli 3 / 4 / 5+ pezzi con la barra allineata ai livelli. Dal quinto pezzo in su
   lo sconto resta 15 euro, come dice il livello "5+ pezzi". 02/10 (Elena): il prodotto della pagina
   sta in cima ("Questo articolo") e segue colore e taglia scelti sopra; le linguette hanno solo gli
   articoli da abbinare. 02/10 sera (Elena): niente linguette, tutti gli articoli Basic in fila.
   Stato solo in pagina; il pulsante fa una sola richiesta e apre il carrello laterale. */
(function () {
  'use strict';
  var box = document.querySelector('[data-av-costruttore]');
  if (!box) return;
  var dati = [];
  try { dati = JSON.parse(box.querySelector('[data-av-costruttore-dati]').textContent); } catch (e) { return; }
  dati = dati.filter(function (p) { return p.var && p.var.length; });
  if (!dati.length) { box.hidden = true; return; }
  var soglie = JSON.parse(box.getAttribute('data-soglie'));
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var scelti = [];
  var righe = [];
  // 02/10 (Simone): "Questo articolo" entra gia' nel set come primo pezzo, col suo prezzo
  var quiTolto = false, pronto = false, quiAggiorna = null;

  function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function tondo(c) { return (c % 100 ? (c / 100).toFixed(2).replace('.', ',') : String(c / 100)) + ' €'; }
  function pezzi(n) { return avT(n === 1 ? 'pezzo' : 'pezzi', { n: n }); }
  function el(tag, cls, testo) { var e = document.createElement(tag); if (cls) e.className = cls; if (testo != null) e.textContent = testo; return e; }
  function sconto(n) { var s = 0; soglie.forEach(function (x) { if (n >= x[0]) s = x[1]; }); return s; }

  var elenco = box.querySelector('[data-av-griglia]');
  var linguette = box.querySelector('[data-av-linguette]');
  var qui = box.querySelector('[data-av-qui]');
  linguette.hidden = true;
  if (!dati.some(function (p) { return !p.qui; })) box.querySelector('[data-av-abbina]').hidden = true;

  dati.forEach(function (p) {
    var riga = el('article', 'av-cs');
    var foto = el('img', 'av-cs__foto'); foto.src = p.foto; foto.alt = ''; foto.width = 64; foto.height = 64; foto.loading = 'lazy';
    var info = el('div', 'av-cs__info');
    var nome = el('a', 'av-cs__nome', avK(p.nome)); nome.href = p.url;
    var sotto = el('div', 'av-cs__sotto');
    var prezzo = el('span', 'av-cs__prezzo');
    var nel = el('span', 'av-cs__nel'); nel.hidden = true;
    sotto.appendChild(prezzo);
    if (p.nota) sotto.appendChild(el('span', 'av-cs__nota', avK(p.nota)));
    sotto.appendChild(nel);
    info.appendChild(nome); info.appendChild(sotto);

    var scelte = el('div', 'av-cs__scelte');
    var colori = [];
    p.var.forEach(function (v) { if (colori.indexOf(v.c) < 0) colori.push(v.c); });
    var selC = null;
    if (colori.length > 1 || colori[0]) {
      selC = el('select', 'av-cs__menu'); selC.setAttribute('aria-label', avT('colore_di', { p: avK(p.nome) }));
      var o0 = el('option', null, avT('colore')); o0.value = ''; o0.disabled = true; o0.selected = true; selC.appendChild(o0);
      colori.forEach(function (c) { var o = el('option', null, avK(c)); o.value = c; selC.appendChild(o); });
      scelte.appendChild(selC);
    }
    var selA = null;
    if (p.var.some(function (v) { return v.a; })) {
      selA = el('select', 'av-cs__menu'); selA.setAttribute('aria-label', avT('alt_di', { a: p.alt ? avK(p.alt) : avT('taglia'), p: avK(p.nome) }));
      scelte.appendChild(selA);
    }
    var btn = el('button', 'av-cs__piu', '+'); btn.type = 'button'; btn.disabled = true;
    btn.setAttribute('aria-label', avT('aggiungi_al_set', { p: avK(p.nome) }));
    scelte.appendChild(btn);

    var min = p.var.reduce(function (m, v) { return Math.min(m, v.p); }, Infinity);
    var testoPrezzo = p.var.some(function (v) { return v.p !== min; }) ? avT('da', { x: euro(min) }) : euro(min);
    prezzo.textContent = testoPrezzo;
    var scelta = null;
    function colore() { return selC ? selC.value : colori[0]; }
    function riempiAlt() {
      if (!selA) return;
      selA.innerHTML = '';
      var z = el('option', null, p.alt ? avK(p.alt) : avT('taglia')); z.value = ''; z.disabled = true; z.selected = true; selA.appendChild(z);
      var perC = p.var.filter(function (v) { return v.c === colore(); });
      perC.forEach(function (v) { var o = el('option', null, avK(v.a)); o.value = v.a; selA.appendChild(o); });
      selA.disabled = !perC.length;
      if (perC.length === 1) selA.value = perC[0].a;
    }
    function risolvi() {
      var perC = p.var.filter(function (v) { return v.c === colore(); });
      scelta = selA ? (perC.filter(function (v) { return v.a === selA.value; })[0] || null) : (perC[0] || null);
      btn.disabled = !scelta;
      prezzo.textContent = scelta ? euro(scelta.p) : testoPrezzo;
      if (scelta && scelta.f) foto.src = scelta.f;
      else if (perC.length && perC[0].f) foto.src = perC[0].f;
      if (p.qui) impostaQui();
    }
    function impostaQui() {
      var i = -1;
      scelti.forEach(function (s, k) { if (s.qui) i = k; });
      if (quiTolto || !scelta) { if (i >= 0) scelti.splice(i, 1); }
      else {
        var voce = { qui: true, pid: p.id, id: scelta.id, nome: avK(p.nome), variante: [scelta.c, scelta.a].filter(Boolean).map(avK).join(' · '), p: scelta.p, f: scelta.f || p.foto };
        if (i >= 0) scelti[i] = voce; else scelti.unshift(voce);
      }
      btn.hidden = !quiTolto && !!scelta;
      if (pronto) disegna();
    }
    if (p.qui) quiAggiorna = impostaQui;
    if (selC) selC.addEventListener('change', function () { riempiAlt(); risolvi(); });
    if (selA) selA.addEventListener('change', risolvi);
    if (selC && colori.length === 1) selC.value = colori[0];
    riempiAlt(); risolvi();
    btn.addEventListener('click', function () {
      if (!scelta) return;
      if (p.qui) { quiTolto = false; impostaQui(); return; }
      scelti.push({ pid: p.id, id: scelta.id, nome: avK(p.nome), variante: [scelta.c, scelta.a].filter(Boolean).map(avK).join(' · '), p: scelta.p, f: scelta.f || p.foto });
      btn.textContent = '✓'; btn.classList.add('av-fatto');
      setTimeout(function () { btn.textContent = '+'; btn.classList.remove('av-fatto'); }, 900);
      disegna();
    });

    riga.appendChild(foto); riga.appendChild(info); riga.appendChild(scelte);
    if (p.qui) {
      qui.appendChild(riga); qui.hidden = false;
      // segue la variante scelta sopra (colore e taglia della scheda)
      var campo = document.querySelector('.product-detail form[action*="/cart/add"] [name="id"]');
      var segui = function () {
        var v = campo && p.var.filter(function (x) { return String(x.id) === String(campo.value); })[0];
        if (!v) {
          // variante esaurita (qui ci sono solo le disponibili): si segue almeno il colore
          var t = document.querySelector('.product-detail .js-option-title');
          var c = t && t.textContent.trim();
          if (selC && c && colori.indexOf(c) >= 0 && selC.value !== c) { selC.value = c; riempiAlt(); risolvi(); }
          return;
        }
        if (selC) selC.value = v.c;
        riempiAlt();
        if (selA) selA.value = v.a;
        risolvi();
      };
      if (campo) {
        segui();
        var form = campo.form || campo.closest('form');
        if (form) form.addEventListener('change', function () { setTimeout(segui, 150); });
        if (window.MutationObserver) new MutationObserver(segui).observe(campo, { attributes: true, attributeFilter: ['value'] });
      }
    } else {
      elenco.appendChild(riga);
    }
    righe.push({ p: p, el: riga, nel: nel });
  });

  var lista = box.querySelector('[data-av-scelti]');
  var tacche = box.querySelectorAll('[data-av-tacca]');
  function disegna() {
    var n = scelti.length, pieno = 0;
    lista.innerHTML = '';
    scelti.forEach(function (s, i) {
      pieno += s.p;
      var li = el('li', 'av-cs-riga');
      var im = el('img'); im.src = s.f; im.alt = ''; im.width = 40; im.height = 40;
      var t = el('div', 'av-cs-riga__testo');
      t.appendChild(el('span', 'av-cs-riga__nome', s.nome));
      if (s.variante) t.appendChild(el('span', 'av-cs-riga__var', s.variante));
      var pr = el('span', 'av-cs-riga__prezzo', euro(s.p));
      var x = el('button', 'av-cs-riga__togli', '×'); x.type = 'button'; x.setAttribute('aria-label', avT('togli', { p: s.nome }));
      x.addEventListener('click', function () {
        if (s.qui && quiAggiorna) { quiTolto = true; quiAggiorna(); return; }
        scelti.splice(i, 1); disegna();
      });
      li.appendChild(im); li.appendChild(t); li.appendChild(pr); li.appendChild(x);
      lista.appendChild(li);
    });
    var sc = sconto(n), tot = pieno - sc;
    box.querySelector('[data-av-conta]').textContent = pezzi(n);
    box.querySelector('[data-av-vuoto]').hidden = n > 0;
    box.querySelector('[data-av-pieno]').textContent = sc ? euro(pieno) : '';
    box.querySelector('[data-av-totale]').textContent = euro(tot);
    box.querySelector('[data-av-risparmio]').textContent = sc ? avT('risparmi', { s: tondo(sc) }) : '';

    // barra divisa come i livelli: il primo tratto si riempie da 0 a 3 pezzi, poi uno per livello
    var da = 0;
    soglie.forEach(function (x, k) {
      var q = Math.max(0, Math.min(1, (n - da) / (x[0] - da)));
      if (tacche[k]) tacche[k].style.width = (q * 100) + '%';
      da = x[0];
    });
    var attuale = 0;
    soglie.forEach(function (x) { if (n >= x[0]) attuale = x[0]; });
    Array.prototype.forEach.call(box.querySelectorAll('[data-av-soglia]'), function (s) {
      var q = Number(s.getAttribute('data-av-soglia'));
      s.classList.toggle('av-raggiunta', n >= q);
      s.classList.toggle('av-attuale', q === attuale);
    });

    var prossima = soglie.filter(function (x) { return n < x[0]; })[0];
    var msg;
    if (!n) msg = avT('scegli', { n: pezzi(soglie[0][0]), s: tondo(soglie[0][1]) });
    else if (!sc) msg = avT('ancora', { n: pezzi(prossima[0] - n), s: tondo(prossima[1]) });
    else if (prossima) msg = avT('raggiunto', { s: tondo(sc), n: pezzi(prossima[0] - n), t: tondo(prossima[1]) });
    else msg = avT('massimo', { s: tondo(sc) });
    box.querySelector('[data-av-prossimo]').textContent = msg;

    righe.forEach(function (r) {
      var k = scelti.filter(function (s) { return s.pid === r.p.id; }).length;
      r.nel.hidden = !k; r.nel.textContent = k > 1 ? avT('nel_set_x', { k: k }) : avT('nel_set');
    });
    Array.prototype.forEach.call(box.querySelectorAll('[data-av-costruttore-aggiungi]'), function (b) {
      b.disabled = n === 0;
      b.textContent = n ? avT('aggiungi_n', { n: pezzi(n) }) : avT('aggiungi');
    });
  }

  Array.prototype.forEach.call(box.querySelectorAll('[data-av-costruttore-aggiungi]'), function (b) {
    b.addEventListener('click', function () {
      if (!scelti.length) return;
      Array.prototype.forEach.call(box.querySelectorAll('[data-av-costruttore-aggiungi]'), function (x) { x.disabled = true; });
      var voci = {};
      scelti.forEach(function (s) { voci[s.id] = (voci[s.id] || 0) + 1; });
      var items = Object.keys(voci).map(function (id) { return { id: Number(id), quantity: voci[id] }; });
      fetch(root + 'cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-AdVille': '1' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        scelti = []; quiTolto = false;
        if (quiAggiorna) quiAggiorna();
        disegna();
        if (window.avApriCarrello) return window.avApriCarrello();
        window.location.href = root + 'cart';
      }).catch(function () { window.location.href = root + 'cart'; });
    });
  });
  pronto = true;
  disegna();
})();

/* AdVille · Pupakiotti · 02/10/2026 · richiesta di Elena: toccando un colore nella scheda, la
   pagina torna da sola alla foto grande del prodotto, che il tema ha gia' spostato su quella del
   colore scelto (o, se quella combinazione non esiste, si va alla foto di quel colore). Si muove
   solo se la foto non e' gia' tutta visibile; tiene conto della barra in
   alto che resta fissa quando si scorre (90 px da telefono, 48 da computer). */
(function () {
  'use strict';
  function barraAlta() {
    var b = document.querySelector('.docked-mobile-navigation-container__inner, .docked-navigation-container__inner');
    if (!b) return 0;
    var s = getComputedStyle(b);
    return (s.position === 'fixed' || s.position === 'sticky') && s.display !== 'none' ? b.getBoundingClientRect().height : 0;
  }
  // Se colore + taglia scelti non esistono (es. Nero non c'e' in 2XS) il tema non cambia foto:
  // qui si va comunque alla foto di quel colore, presa da una sua variante qualsiasi.
  function fotoDelColore() {
    var gruppo = document.querySelector('.product-detail [class*="option-selector--colo"]');
    var json = document.querySelector('.product-detail [data-product-json]') || document.querySelector('[data-product-json]');
    if (!gruppo || !json) return;
    var scelto = gruppo.querySelector('input:checked') || gruppo.querySelector('select');
    var colore = scelto && scelto.value;
    var prodotto; try { prodotto = JSON.parse(json.textContent); } catch (e) { return; }
    if (!colore || !prodotto || !prodotto.variants) return;
    var i = prodotto.options.map(function (o) { return String(o.name || o).toLowerCase(); }).findIndex(function (n) { return n.indexOf('colo') === 0; });
    if (i < 0) return;
    var v = prodotto.variants.filter(function (x) { return x.options[i] === colore && x.featured_media; })[0];
    if (!v) return;
    var media = document.querySelector('.product-detail .product-detail__image [data-media-id="' + v.featured_media.id + '"]');
    var slide = media && media.closest('.slick-slide');
    if (!slide || slide.classList.contains('slick-current')) return;
    var giostra = slide.closest('.slick-slider');
    var n = Number(slide.getAttribute('data-slick-index'));
    // il carosello del tema (slick) si comanda dall'elemento: il jQuery globale della pagina e' di un'app
    if (giostra && giostra.slick && giostra.slick.slickGoTo) giostra.slick.slickGoTo(n);
    else if (giostra && window.jQuery && window.jQuery.fn.slick) window.jQuery(giostra).slick('slickGoTo', n);
  }
  var attesa = null;
  function risali(e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.product-detail [class*="option-selector--colo"]')) return;
    // anche se si tocca il colore gia' scelto (in quel caso il tema non cambia nulla)
    clearTimeout(attesa);
    attesa = setTimeout(function () {
      try { fotoDelColore(); } catch (err) {}
      var foto = document.querySelector('.product-detail .product-detail__image.slick-current') || document.querySelector('.product-detail .product-detail__image');
      if (!foto) return;
      var r = foto.getBoundingClientRect();
      var alto = Math.max(barraAlta(), window.innerWidth < 768 ? 90 : 48) + 8;
      if (r.top >= alto - 2 && r.bottom <= window.innerHeight) return;
      window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - alto), behavior: 'smooth' });
    }, 120);
  }
  document.addEventListener('click', risali);
  document.addEventListener('change', risali);
})();

/* AdVille · Pupakiotti · 02/10/2026 · nella scheda le taglie che nel colore scelto sono esaurite
   (0 pezzi in Shopify) o non esistono si vedono barrate: prima sembravano disponibili e solo
   dopo il clic compariva "Esaurito" con il modulo di avviso dell'app Ordersify. Cliccandole si
   puo' ancora chiedere l'avviso. Solo per prodotti con due opzioni, una delle quali e' il colore. */
(function () {
  'use strict';
  var json = document.querySelector('[data-section-type="product"] [data-product-json]') || document.querySelector('[data-product-json]');
  if (!json) return;
  var prodotto; try { prodotto = JSON.parse(json.textContent); } catch (e) { return; }
  if (!prodotto || !prodotto.options || prodotto.options.length !== 2) return;
  var nomi = prodotto.options.map(function (o) { return String(o.name || o).toLowerCase(); });
  var iCol = nomi[0].indexOf('colo') === 0 ? 0 : (nomi[1].indexOf('colo') === 0 ? 1 : -1);
  if (iCol < 0) return;
  var iAlt = 1 - iCol;
  function segna() {
    var gCol = document.querySelector('.product-detail [data-index="option' + (iCol + 1) + '"]');
    var gAlt = document.querySelector('.product-detail [data-index="option' + (iAlt + 1) + '"]');
    if (!gCol || !gAlt) return;
    var c = (gCol.querySelector('input:checked') || {}).value;
    if (!c) return;
    Array.prototype.forEach.call(gAlt.querySelectorAll('input.js-option'), function (inp) {
      var lab = gAlt.querySelector('label[for="' + inp.id + '"]');
      if (!lab) return;
      var v = prodotto.variants.filter(function (x) { return x.options[iCol] === c && x.options[iAlt] === inp.value; })[0];
      var no = !v || !v.available;
      lab.classList.toggle('av-esaurita', no);
      if (no) lab.setAttribute('title', v ? 'Esaurita in questo colore' : 'Non disponibile in questo colore'); else lab.removeAttribute('title');
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.product-detail .option-selector')) setTimeout(segna, 50);
  });
  segna();
})();

/* AdVille · Pupakiotti · 07/10/2026 · richiesta di Sergio: dalle email si arriva dritti a
   scrivere la recensione. Il link e' la scheda del prodotto con #scrivi-recensione: la pagina
   apre da sola il modulo di Judge.me (il resto del suo widget resta nascosto, perche' sulle
   schede si mostrano le recensioni del negozio) e ci scorre sopra. */
window.avApriRecensione = function (tentativi) {
  var w = document.querySelector('.jdgm-review-widget');
  if (!w) return;
  var widg = w.querySelector('.jdgm-rev-widg');
  var link = w.querySelector('.jdgm-write-rev-link');
  // Judge.me deve aver finito di prepararsi: quando e' pronto mette questa classe al widget
  if (!widg || !link || !w.classList.contains('jdgm--done-setup-widget')) {
    if (tentativi < 30) setTimeout(function () { window.avApriRecensione(tentativi + 1); }, 400);
    return;
  }
  w.classList.add('av-scrivi-aperto');
  var modulo = w.querySelector('.jdgm-form-wrapper');
  if (!modulo || modulo.offsetHeight === 0) link.click();
  var giri = 0;
  (function attendi() {
    var m = w.querySelector('.jdgm-form-wrapper');
    // Judge.me crea il modulo ma lo lascia chiuso: lo mostriamo noi (l'invio resta suo)
    if (m && m.offsetHeight === 0 && giri > 2) m.style.display = 'block';
    if ((m && m.offsetHeight > 0) || giri++ > 25) {
      var y = (m || w).getBoundingClientRect().top + window.pageYOffset - 110;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    } else setTimeout(attendi, 200);
  })();
};
(function () {
  if (location.hash !== '#scrivi-recensione') return;
  var via = function () { setTimeout(function () { window.avApriRecensione(0); }, 800); };
  if (document.readyState === 'complete') via(); else window.addEventListener('load', via);
})();
